import PropTypes from 'prop-types';
import { Loader } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getMorePlpDetails } from '../../../../../store/plp/actions';
import { PAGE_SIZE } from '../../constants';
import { buildLoadMoreUrl, setUrlWithoutScrollToProduct } from '../utils';
import { PAGE_BREAKPOINTS, STATUS } from '@app/constants/commonConstants';
import useAnalytics from '../../../../../hooks/useAnalytics';
import { useHistory, useRouteMatch } from 'react-router';
import { useBreakpoint } from '@app/hooks';
import cx from 'classnames';

const ProductListLoadMore = () => {
  const [t] = useTranslation();
  const history = useHistory();
  const { url } = useRouteMatch();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const widthClassName = isMD ? 'w-auto' : 'w-100';
  const getMorePlpDetailsStatus = useSelector(
    state => state.plpUI.getMorePlpDetailsStatus
  );
  const currentCategory = useSelector(state => state.plpUI.current);
  const loading = getMorePlpDetailsStatus === STATUS.PENDING;
  const { dispatchWithImpressionEvent } = useAnalytics();
  const catalogEntries = useSelector(
    state => state.categories.byId[currentCategory]?.productsId
  );
  const lowestLoadedPage = useSelector(state => state.plpUI.lowestLoadedPage);

  // get count of preceding products no loaded
  const unloadedPreviousPageProductCount = (lowestLoadedPage - 1) * PAGE_SIZE;
  const lastPageLoaded = Math.ceil(
    ((catalogEntries ?? []).length + unloadedPreviousPageProductCount) /
      PAGE_SIZE
  );
  const loadMoreUrl = buildLoadMoreUrl(lastPageLoaded);
  const handleShowMoreClick = e => {
    e.preventDefault();
    setUrlWithoutScrollToProduct(url, history);
    if (!loading) {
      dispatchWithImpressionEvent(
        getMorePlpDetails({ offset: lastPageLoaded })
      );
    }
  };

  return (
    <div className="text-center">
      {loading ? (
        <Loader size="small" />
      ) : (
        <a
          href={loadMoreUrl}
          onClick={handleShowMoreClick}
          className={cx('btn btn-secondary btn-sm', widthClassName)}
        >
          {t('LOAD_MORE')}
        </a>
      )}
    </div>
  );
};

export default ProductListLoadMore;
